import { createSelector } from "@reduxjs/toolkit";

import type { Coachmark } from "entities/coachmarks/types";
import type { RootState } from "types";

export const getCoachmarksInDOM = (state: RootState) => state.domains.coachmarks.inDOMIds;

export const getCoachmarksAreEnabled = (state: RootState) => state.domains.coachmarks.isEnabled;

export const getUsedCoachmarks = (state: RootState) => state.domains.coachmarks.usedIds;

export const getUnusedCoachmarksInDOM = createSelector(
  getCoachmarksInDOM,
  getUsedCoachmarks,
  (state: RootState) => state.entities.coachmarks.byId,
  (inDOMIds, usedIds, coachmarksById) =>
    Object.keys(coachmarksById).reduce<Coachmark[]>((accumulator, next) => {
      const coachmark = coachmarksById[next];
      if (coachmark !== undefined && !usedIds.includes(next) && inDOMIds.includes(next)) accumulator.push(coachmark);
      return accumulator;
    }, []),
);

export const getCoachmarksAreShowing = (state: RootState) =>
  (getCoachmarksAreEnabled(state) ?? false) && getUnusedCoachmarksInDOM(state).length !== 0;
